import React from 'react';
import { PLANS_CATEGORIES } from 'datamodel/plans/constants';
import Plans from '../plans';

const Gold = (props) => <Plans {...props} categories={[PLANS_CATEGORIES.MATCHING]} />;

export default Gold;
